import { render } from "./IsoVoyageImage.vue?vue&type=template&id=00b0a044"
import script from "./IsoVoyageImage.vue?vue&type=script&lang=js"
export * from "./IsoVoyageImage.vue?vue&type=script&lang=js"

import "./IsoVoyageImage.vue?vue&type=style&index=0&id=00b0a044&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__